import { serviceMapper as remittances } from './remittances'
import { serviceMapper as cashCount } from './cashCount'
import { serviceMapper as user } from './user'
import { serviceMapper as admin } from './admin'

const services = { ...remittances, ...cashCount, ...user, ...admin }

export default services
